import {
    GET_AZURE_THRESHOLD_SUCCESS,
    GET_AZURE_THRESHOLD_FAIL,
    GET_AZURE_THRESHOLD,
    PUT_AZURE_THRESHOLD,
    PUT_AZURE_THRESHOLD_FAIL,
    PUT_AZURE_THRESHOLD_SUCCESS,
    POST_DISABLE_AZURE_THRESHOLD_ALERTS_FAIL,
    POST_DISABLE_AZURE_THRESHOLD_ALERTS_SUCCESS,
    POST_DISABLE_AZURE_THRESHOLD_ALERTS,
    POST_ENABLE_AZURE_THRESHOLD_ALERTS,
    POST_ENABLE_AZURE_THRESHOLD_ALERTS_FAIL,
    POST_ENABLE_AZURE_THRESHOLD_ALERTS_SUCCESS
} from "./actionTypes";

export const getAzureThreshold = (data) => ({
    type: GET_AZURE_THRESHOLD,
    payload: data
})

export const getAzureThresholdSuccess = azure_threshold => ({
    type: GET_AZURE_THRESHOLD_SUCCESS,
    payload: azure_threshold,
})

export const getAzureThresholdFail = error => ({
    type: GET_AZURE_THRESHOLD_FAIL,
    payload: error,
})

export const putAzureThreshold = (data) => ({
    type: PUT_AZURE_THRESHOLD,
    payload: { data }
})

export const putAzureThresholdSuccess = (azure_threshold) => ({
    type: PUT_AZURE_THRESHOLD_SUCCESS,
    payload: { azure_threshold }
})

export const putAzureThresholdFail = error => ({
    type: PUT_AZURE_THRESHOLD_FAIL,
    payload: error,
})

export const postDisableAzureThresholdAlerts = (data) => ({
    type: POST_DISABLE_AZURE_THRESHOLD_ALERTS,
    payload: { data }
})

export const postEnableAzureThresholdAlerts = (data) => ({
    type: POST_ENABLE_AZURE_THRESHOLD_ALERTS,
    payload: { data }
})

export const postEnableAzureThresholdAlertsSuccess = azure_threshold => ({
    type: POST_ENABLE_AZURE_THRESHOLD_ALERTS_SUCCESS,
    payload: azure_threshold,
})

export const postDisableAzureThresholdAlertsSuccess = azure_threshold => ({
    type: POST_DISABLE_AZURE_THRESHOLD_ALERTS_SUCCESS,
    payload: azure_threshold,
})

export const postEnableAzureThresholdAlertsFail = error => ({
    type: POST_ENABLE_AZURE_THRESHOLD_ALERTS_FAIL,
    payload: error,
})

export const postDisableAzureThresholdAlertsFail = error => ({
    type: POST_DISABLE_AZURE_THRESHOLD_ALERTS_FAIL,
    payload: error,
})